import React from 'react';

import BaseIcon, { type BaseIconProps } from '../BaseIcon';

const ChatIcon: React.FC<BaseIconProps> = ({ ...rest }) => {
  return (
    <BaseIcon {...rest} viewBox="0 0 32 32" fill="none">
      <path
        d="M10 16H10.0133M16 16H16.0133M22 16H22.0133M16 28C22.6274 28 28 22.6274 28 16C28 9.37258 22.6274 4 16 4C9.37258 4 4 9.37258 4 16C4 17.5962 4.31165 19.1196 4.87742 20.5127C4.9857 20.7793 5.03984 20.9126 5.06399 21.0204C5.08762 21.1258 5.09626 21.2038 5.09628 21.3118C5.09629 21.4223 5.07624 21.5426 5.03614 21.7831L4.2455 26.527C4.16271 27.0238 4.12131 27.2721 4.19835 27.4518C4.26577 27.609 4.39104 27.7342 4.54825 27.8017C4.72786 27.8787 4.97624 27.8373 5.47301 27.7545L10.2169 26.9639C10.4574 26.9238 10.5777 26.9037 10.6882 26.9037C10.7962 26.9037 10.8742 26.9124 10.9796 26.936C11.0874 26.9602 11.2207 27.0143 11.4873 27.1226C12.8804 27.6884 14.4038 28 16 28ZM10.6667 16C10.6667 16.3682 10.3682 16.6667 10 16.6667C9.63181 16.6667 9.33333 16.3682 9.33333 16C9.33333 15.6318 9.63181 15.3333 10 15.3333C10.3682 15.3333 10.6667 15.6318 10.6667 16ZM16.6667 16C16.6667 16.3682 16.3682 16.6667 16 16.6667C15.6318 16.6667 15.3333 16.3682 15.3333 16C15.3333 15.6318 15.6318 15.3333 16 15.3333C16.3682 15.3333 16.6667 15.6318 16.6667 16ZM22.6667 16C22.6667 16.3682 22.3682 16.6667 22 16.6667C21.6318 16.6667 21.3333 16.3682 21.3333 16C21.3333 15.6318 21.6318 15.3333 22 15.3333C22.3682 15.3333 22.6667 15.6318 22.6667 16Z"
        stroke="currentColor"
        strokeWidth="2.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </BaseIcon>
  );
};

export default ChatIcon;
